import {Injectable} from '@angular/core';
import {DomSanitizer} from '@angular/platform-browser';
import {MatIconRegistry} from '@angular/material/icon';

@Injectable({providedIn: 'root'})
export class IconService {
  icons: { url: string, name: string }[] = [
    {url: 'assets/images/store/icons/ic_round-flag-circle-black.svg', name: 'earn'},
    {url: 'assets/images/store/icons/ic_round-playlist-add-check-circle-black.svg', name: 'redeem'},
    {url: 'assets/images/store/icons/ic_round-account-circle-black.svg', name: 'profile'},
    {url: 'assets/images/store/icons/ic_round-cloud-circle-black.svg', name: 'wallet'},
    {url: 'assets/images/store/icons/ic_round-shopping-cart-black.svg', name: 'shop'},
    {url: 'assets/images/store/icons/ic_round-play-circle-black.svg', name: 'player'},
    {url: 'assets/images/store/icons/ic_round-alternate-email-black.svg', name: 'chat'},
    {url: 'assets/images/store/icons/ic_round-more.svg', name: 'more'},
    {url: 'assets/images/store/icons/ic_round-log-out.svg', name: 'logout'},
    {url: 'assets/images/store/icons/main-button-icon.svg', name: 'main'},
    {url: 'assets/images/store/icons/player-btn.svg', name: 'player'},
    {url: 'assets/images/store/icons/ic_round-arrow-back-player.svg', name: 'back-btn'},
    {url: 'assets/images/store/icons/ic_round-playing-track.svg', name: 'playing-track'},
    {url: 'assets/images/store/icons/ic_round-remove-circle.svg', name: 'remove-tab'},
    {url: 'assets/images/store/icons/ic_round-add-circle.svg', name: 'add-tab'},
    {url: 'assets/images/store/icons/ic_round-cloud-circle.svg', name: 'nfts'},
    {url: 'assets/images/store/icons/ic_round-cloud-circle.svg', name: 'create nft'},
    {url: 'assets/images/store/icons/ic_round-playlist-add-check-circle.svg', name: 'owned'},
    {url: 'assets/images/store/icons/ic_round-circle-notifications.svg', name: 'notifications'},
    {url: 'assets/images/store/icons/ic_round-check-circle.svg', name: 'superagi'},
    {url: 'assets/images/store/icons/ic_round-explore.svg', name: 'explore'},
  ];

  constructor(private iconRegistry: MatIconRegistry, sanitizer: DomSanitizer) {
    this.icons.forEach(icons => this.iconRegistry.addSvgIcon(icons.name, sanitizer.bypassSecurityTrustResourceUrl(icons.url)));
  }
}
